import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { default as pt } from 'prop-types';
import styles from './styles.scss';

export const TimeFilter = ({ times, handleSelection, selectedTime }) => {
  return (
    <Dropdown
      options={times}
      className={`${styles['time']} test-time-filter-dropdown`}
      value={selectedTime}
      type="time"
      onChange={handleSelection}
    />
  );
};

TimeFilter.propTypes = {
  times: pt.array.isRequired,
  selectedTime: pt.string,
  handleSelection: pt.func,
};



// WEBPACK FOOTER //
// ./src/common/components/filter/TimeFilter.js